/**
 * Block-for-block skeleton for the /my-family page (Plan 06).
 *
 * Mirrors the live layout in order: page header, the compact
 * Students-linked list (rows + add tile), the Auto-Order card,
 * co-owners, and the claim-code card. Never render a plain
 * `Loading...` string here.
 */

import { Card, CardContent, CardHeader } from '@ordo/ui/card'
import { Skeleton } from '@ordo/ui/skeleton'

export function MyFamilySkeleton() {
  return (
    <div
      className="mx-auto flex h-full w-full max-w-[100rem] flex-col gap-6 p-4 lg:pt-5"
      aria-busy="true"
      aria-label="Loading family">
      <header className="flex items-center gap-3 border-b border-border pb-4">
        <Skeleton className="h-9 w-9 rounded-md" />
        <Skeleton className="h-8 w-40" />
      </header>

      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-40" />
          <Skeleton className="mt-1 h-3 w-64" />
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <CompactStudentRowSkeleton />
          <CompactStudentRowSkeleton />
          <Skeleton className="h-[3.25rem] w-full rounded-lg" />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-28" />
          <Skeleton className="mt-1 h-3 w-72" />
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <AutoOrderRowSkeleton />
          <AutoOrderRowSkeleton />
          <Skeleton className="mt-1 h-3 w-80" />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <Skeleton className="h-5 w-28" />
          <Skeleton className="h-9 w-32" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-20 w-full rounded-md" />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <Skeleton className="h-5 w-44" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-10 w-full rounded-md" />
        </CardContent>
      </Card>
    </div>
  )
}

function CompactStudentRowSkeleton() {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border px-3 py-2.5">
      <Skeleton className="h-9 w-9 rounded-full" />
      <div className="flex-1 space-y-1.5">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton className="h-4 w-10" />
    </div>
  )
}

function AutoOrderRowSkeleton() {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border px-3 py-2.5">
      <Skeleton className="h-9 w-9 rounded-full" />
      <div className="flex-1 space-y-1.5">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
      <Skeleton className="h-5 w-5 rounded" />
    </div>
  )
}
